import React from 'react';
import { BookOpenIcon, FolderOpenIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 tomos completos'
}, {
  icon: GiftIcon,
  label: '5 bonos estratégicos'
}, {
  icon: FolderOpenIcon,
  label: '+300 recursos listos para usar'
}, {
  icon: UsersIcon,
  label: 'Docentes, estudiantes y profesionales'
}];
export function SocialProof() {
  return <section className="bg-emerald-900 py-5" aria-label="Contenido del Megapack" data-id="element-223" data-mp="3ebmjbaalryk">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-stone-50 sm:justify-between" data-id="element-224" data-mp="8dy7k6wd4chx">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-225" data-mp="3ut0uwut0f5qa">
            <Icon className="h-5 w-5 text-amber-400" aria-hidden="true" data-id="element-226" data-mp="3ur6aripkbhn9" /> {label}
          </span>)}
      </div>
    </section>;
}